import React from 'react';
import { useParams } from 'react-router-dom';
import { Card } from '~/components/Card';

interface ExpiredParams {
    token: string;
}

export function Expired() {
    const { token } = useParams<ExpiredParams>();
    return (
        <Card title="Expired Password">
            <p>Your current password has expired. Please continue to create a new password.</p>
            <p className="text-center">
                <a href={`/reset-password/reset/${token}`} className="btn btn-primary">
                    Continue
                </a>
            </p>
        </Card>
    );
}
